import { request } from 'data/requests/request';

const crossSaleRequest = (quoteItemId) =>
    request({ type: 'crossSale', url: `crosssell/check/index/quoteItemId/${quoteItemId}`, notApi: true });

export default crossSaleRequest;
